import { render, staticRenderFns } from "./AlarmLogging.vue?vue&type=template&id=a280b6a8&scoped=true"
import script from "./AlarmLogging.vue?vue&type=script&lang=js"
export * from "./AlarmLogging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a280b6a8",
  null
  
)

export default component.exports